import { useContext } from 'react'
import { AuthContext, type Auth } from './context'

export function useAuth(): Auth {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used inside AuthProvider')
  return ctx
}
